import { put, call, take, fork } from 'redux-saga/effects';
import { getCourseDocumentByIdService } from '../../api/assignment';
//import { questionPatchSuccess } from '../../reducers/question/action'
//import { getCourseDocumentByIdSuccess } from '../../reducers/assignment/action';
import { GET_COURSE_DOCUMENT_BY_ID } from '../../reducers/assignment/type';
import generalSaga from '../general';
import { operationSuccess, operationFail } from '../../reducers/operation/action';

/**
 *
 * @param {*} payload
 */
function* getCourseDocumentByIdFlow(payload) {
  try {
    const { courseId, callback } = payload;
    const response = yield call(getCourseDocumentByIdService, courseId);

    yield put(operationSuccess());

    callback(response.data);
  } catch (error) {
    yield put(operationFail(error));
  }
}

/**
 *
 */
export default function* getCourseDocumentByIdWatcher() {
  while (true) {
    const action = yield take(GET_COURSE_DOCUMENT_BY_ID);
    const { payload } = action;

    yield fork(generalSaga, getCourseDocumentByIdFlow, payload);
  }
}
